(function() {

    'use strict';

    angular.module('Services').factory('ClientAccountListTableService', ClientAccountListTableService);

    function ClientAccountListTableService($location, ClientService, TableLiteFactory) {
        return function (companyId) {
            var companiesListTableData = {
                tableName: 'ClientAccountListTableService',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add New Account',
                        onClick: function () {
                            //$location.path('/clients/account/details');
                            $location.path(`/clients/${companyId}/account/`);
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'Location',
                    viewName: 'locationName',
                    filterName: 'office.name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Group', //header name
                    viewName: 'groupName', //Attribute name on what to display from data
                    filterName: 'permissionGroup.name',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    } //Use for sorting
                }, {
                    label: 'Name',
                    viewName: 'contactPerson',
                    filterName: 'fullName',
                    sortName: 'firstName',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.sortName);
                    }
                }, {
                    label: 'Email',
                    viewName: 'email',
                    filterName: 'email',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Phone',
                    viewName: 'phoneNumbers',
                    filterName: 'phone1',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Active', 'Inactive'],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model === 'Active';
                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },],
                data: []
            };
            const tableActions = new TableLiteFactory(companiesListTableData,
                {
                    serviceCallback: ClientService.Account.getAll,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
                        'company.id': companyId
                    }
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data, pagination) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);

                angular.forEach(data.content, function (client) {
                    client.phoneNumbers = {
                        type: 'multiLine',
                        list: []
                    };
                    client.groupName = client.permissionGroup.name ? client.permissionGroup.name : 'N/A';
                    client.locationName = client.office.name ? client.office.name : 'N/A';
                    if (client.firstName || client.lastName)
                        client.contactPerson = client.firstName + ' ' + client.lastName;
                    else if (!client.firstName && !client.lastName)
                        client.contactPerson = 'N/A';
                    if (client.phone1)
                        client.phoneNumbers.list.push(client.phone1);
                    if (client.phone2)
                        client.phoneNumbers.list.push(client.phone2);
                    if (!client.phone1 && !client.phone2)
                        client.phoneNumbers = 'N/A';

                    client.status = {
                        type: 'status',
                        status: client.active,
                        label: client.active ? 'Active' : 'Inactive'
                    }
                    client.href = `/clients/${client.company.id}/account/${client.id}?`;
                    companiesListTableData.data.push(client);
                });
            };
            this.tableData = companiesListTableData;
        }
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/ClientAccountListTableService.js